import { Dictionaries } from './enums';

const statusDropdownSortOrder = {
  [Dictionaries.ClientStatus]: [
    'PROSPECT',
    'RELATING',
    'DISCOVERING',
    'ADVOCATING',
    'CONTRACT_SIGNED',
    'SERVICE',
    'INACTIVE'
  ],
  [Dictionaries.JobStatus]: [
    'DRAFT',
    'ACTIVE',
    'COMPLETED',
    'ON_HOLD',
    'INACTIVE'
  ],
  [Dictionaries.JobseekerStage]: [
    'ACTIVE_CANDIDATE_JOBSEEKER_STAGE',
    'PROCESSING_JOBSEEKER_STAGE',
    'CLOSED_HIRE_JOBSEEKER_STAGE',
    'TERMINATED_JOBSEEKER_STAGE',
    'WAITING_LIST_JOBSEEKER_STAGE',
    'INACTIVE_JOBSEEKER_STAGE',
    'TO_CLARIFY_JOBSEEKER_STAGE'
  ]
};

export default statusDropdownSortOrder;
